export const revealStudioPeriods = (list: HTMLElement, preferredId?: string): void => {
  const selected = Array.from(list.querySelectorAll<HTMLButtonElement>('button[aria-pressed="true"]'));
  if (!selected.length || !list.clientHeight) return;
  const first = selected[0];
  const last = selected[selected.length - 1];
  let top = first.offsetTop;
  let bottom = last.offsetTop + last.offsetHeight;
  if (bottom - top > list.clientHeight) {
    const target = selected.find((button) => button.dataset.periodId === preferredId) ?? first;
    top = target.offsetTop;
    bottom = target.offsetTop + target.offsetHeight;
  }
  if (top < list.scrollTop) list.scrollTop = top;
  else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
};
